<template>
    <div class="step2">
        <h1>Aanvraagformulier</h1>
        <h2>Persoonlijk</h2>

        <application-stepper current-step="2" :loading="!loaded">
            <h3>Persoonlijk</h3>

            <v-form @submit.prevent="submit">
                <v-error-messages ref="errorMessages" :messages="this.errorMessages"></v-error-messages>

                <v-radio-group :error="hasErrors('gender')" :error-messages="handleErrors('gender')" label="Geslacht" v-model="applicant.gender" row>
                    <v-radio key="male" label="man" value="male"></v-radio>
                    <v-radio key="female" label="vrouw" value="female"></v-radio>
                    <v-radio key="other" label="gender neutraal" value="other"></v-radio>
                </v-radio-group>

                <v-text-field v-model="applicant.initials" label="Voorletters" readonly></v-text-field>
                <v-text-field v-model="applicant.lastname" label="Achternaam" readonly></v-text-field>
                <v-text-field v-model="applicant.city" label="Plaatsnaam" readonly></v-text-field>
                <v-text-field v-model="applicant.address" label="Adres" readonly></v-text-field>
                <v-text-field v-model="applicant.zipcode" label="Postcode" readonly></v-text-field>
                <v-text-field v-model="applicant.phone" label="Telefoonnummer" readonly></v-text-field>
                <v-text-field v-model="applicant.email" label="E-mail" readonly></v-text-field>
                <v-text-field v-model="applicant.birthdate" label="Geboortedatum" readonly></v-text-field>
                <v-text-field :error="hasErrors('education')" :error-messages="handleErrors('education')" v-model="applicant.education" label="Opleiding"></v-text-field>
                <v-text-field :error="hasErrors('profession')" :error-messages="handleErrors('profession')" v-model="applicant.profession" label="Beroep"></v-text-field>

                <v-row>
                    <v-spacer></v-spacer>
                    <v-col cols="auto">
                        <v-btn @click="back" :loading="backBtnClicked" :disabled="submitting">Vorige</v-btn>
                    </v-col>
                    <v-col cols="auto">
                        <v-btn color="primary" @click="submit" :loading="submitBtnClicked" :disabled="submitting"
                            >Volgende</v-btn
                        >
                    </v-col>
                </v-row>
            </v-form>
        </application-stepper>
    </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import ApplicationStepper from '../components/ApplicationStepper';
import VErrorMessages from '@/components/VErrorMessages';

export default {
    name: 'step2-contact',
    components: {
        ApplicationStepper,
        VErrorMessages,
    },
    data: () => ({
        errorDetails: {},
        loaded: false,
        backBtnClicked: false,
        submitBtnClicked: false,
        submitting: false,

        errorMessages: [],
        applicant: {
            // read only
            initials: null,
            lastname: null,
            city: null,
            address: null,
            zipcode: null,
            phone: null,
            email: null,
            birthdate: null,
            // read/write
            gender: null,
            education: null,
            profession: null,
        },
    }),
    computed: {
        ...mapGetters({ vuex: 'step2' }),
    },
    created: function() {
        const that = this;

        this.step2Load().then(function() {
            // read only
            that.applicant.initials = that.vuex.applicant.initials;
            that.applicant.lastname = that.vuex.applicant.lastname;
            that.applicant.city = that.vuex.applicant.city;
            that.applicant.address = that.vuex.applicant.address;
            that.applicant.zipcode = that.vuex.applicant.zipcode;
            that.applicant.phone = that.vuex.applicant.phone;
            that.applicant.email = that.vuex.applicant.email;
            that.applicant.birthdate = that.vuex.applicant.birthdate;
            // read/write
            that.applicant.gender = that.vuex.applicant.gender;
            that.applicant.education = that.vuex.applicant.education;
            that.applicant.profession = that.vuex.applicant.profession;

            that.loaded = true;
        });
    },
    methods: {
        ...mapActions(['step2Load', 'step2Submit']),
        hasErrors(name) {
            return '' !== this.handleErrors(name);
        },
        handleErrors(name) {
            if (this.errorDetails[name] !== undefined) {
                let error = '';
                Object.entries(this.errorDetails[name]).forEach(entry => {
                    const [errorType, value] = entry;
                    error += " " + value;
                });
                return error;
            }
            return '';
        },
        back: function() {
            const that = this;
            this.backBtnClicked = true;
            this.submitting = true;
            this.errorMessages = [];

            this.step2Submit({ applicant: this.applicant }).finally(function() {
                that.$router.push({ name: 'step1_reason' });
                that.backBtnClicked = false;
                that.submitting = false;
            });
        },
        submit: function() {
            const that = this;
            this.submitBtnClicked = true;
            this.submitting = true;
            this.errorMessages = [];

            this.step2Submit({ applicant: this.applicant })
                .then(function() {
                    that.$router.push({ name: 'step3_household' });
                })
                .catch(function (error) {
                    const response = error.response;
                    if (response.data !== undefined && response.data.error !== undefined) {
                        that.errorDetails = response.data.error.messages;
                        that.errorMessages = ['Er ontbreken gegevens in deze stap'];
                    } else {
                        that.errorMessages = ['Onbekende fout!'];
                    }
                    that.$vuetify.goTo(that.$refs.errorMessages, {
                        duration: 300,
                        offset: 100,
                        easing: 'easeInOutCubic',
                    });
                })
                .finally(function() {
                    that.submitBtnClicked = false;
                    that.submitting = false;
                });
        },
    },
};
</script>
